import { UseFormRegisterReturn } from "react-hook-form";
import { cn } from "@/utils/classes";
import { cva, type VariantProps } from "class-variance-authority";

/* Variants */
const variants = cva("checkbox", {
  variants: {
    variant: {
      default: "radio-neutral text-neutral-content",
      primary: "checkbox-primary",
      secondary: "checkbox-secondary",
      accent: "checkbox-accent",
    },
    size: {
      sm: "checkbox-sm rounded-md",
      md: "checkbox-md",
      lg: "checkbox-lg",
    },
    error: {
      true: "checkbox-error",
      false: "",
    },
  },
  defaultVariants: {
    size: "md",
    variant: "default",
  },
});

/* Prop Types */
interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size">, Omit<VariantProps<typeof variants>, "error"> {
  label?: string;
  error?: string | boolean;
  registration?: UseFormRegisterReturn;
  className?: string;
  variant?: VariantProps<typeof variants>["variant"];
  size?: VariantProps<typeof variants>["size"];
}

/*
 * Checkbox Component
 */
export const Checkbox = ({ label, error, registration, className = "", variant, size, ...props }: CheckboxProps) => {
  /* Render */
  return (
    <fieldset className="fieldset">
      <label className="label cursor-pointer justify-start">
        <input type="checkbox" className={cn(variants({ variant, size, error: !!error, className }))} {...registration} {...props} />
        {label && <span className="ml-1 text-sm text-neutral">{label}</span>}
      </label>
      {error && (
        <label className="label">
          <span className="text-error">{error}</span>
        </label>
      )}
    </fieldset>
  );
};
